
import "./App.css";
import RoutesWrapper from "./routes/route-wrapper";
import { Toaster } from "sonner";

function App() {

  return (
    <>
      <RoutesWrapper />
       <Toaster position="top-right" />
    </>
  );
}

export default App;
